import { render } from "./OapBeautyGeniusCardExpandedInGrid.vue?vue&type=template&id=583dae7c"
import script from "./OapBeautyGeniusCardExpandedInGrid.vue?vue&type=script&lang=js"
export * from "./OapBeautyGeniusCardExpandedInGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__